import type { FutyclubConfig } from "./types";
import { config as developmentConfig } from "./development";
import { config as productionConfig } from "./production";

// Vite exposes import.meta.env.MODE which is 'development' or 'production'
// based on the --mode flag or the build command
const config: FutyclubConfig = import.meta.env.MODE === "production" ? productionConfig : developmentConfig;

export default config;
export type { FutyclubConfig } from "./types";
